export default __webpack_public_path__ + "static/foxnews-f68f8a8abeea3c2eaf102b7aaa7b5cde.png";